import * as React from 'react';
import get from 'lodash/get';

let originTitle = '';

export function withDocumentTitleFromProps<P> (...prefixPropPath: string[]){
  return (
    WrappedComponent: React.ComponentClass<P> | React.FC<React.PropsWithChildren<P>>
  ) => {
    return class extends React.Component<P & { url: string }> {

      private segments: string[] = [];

      public constructor(props: P & { url: string }){
        super(props);
        if(!originTitle){
          originTitle = document.title;
        }
      }

      private updateTitle = () => {
        this.segments.push(originTitle);
        prefixPropPath.forEach(p=>{
          const infoPrefix = get(this.props, p);
          if(infoPrefix){
            const limitedContentLength = infoPrefix.toString().substring(0,50);
            this.segments.push(limitedContentLength);
          }
        });
        const nextTitle = this.segments.reverse().join(' • ');
        if(nextTitle && nextTitle !== document.title){
          document.title = nextTitle;
        }
      };

      public componentDidMount(){
        this.updateTitle();
      }

      public componentWillUnmount(){
        document.title = originTitle;
      }

      public render() {
        return <WrappedComponent {...this.props} />;
      }
    };
  };
}
